import { Tabs } from "radix-ui";
import { ReactNode } from "react";
import useLocalStorageState from "use-local-storage-state";

export const TabsRoot = (props: {
  defaultValue?: string;
  children: ReactNode;
  localStorageKey?: string;
}) => {
  if (props.localStorageKey) {
    return (
      <PersistedTabsRoot
        defaultValue={props.defaultValue}
        localStorageKey={props.localStorageKey}
      >
        {props.children}
      </PersistedTabsRoot>
    );
  }
  return (
    <Tabs.Root defaultValue={props.defaultValue} className="c-tabs">
      {props.children}
    </Tabs.Root>
  );
};
const PersistedTabsRoot = (props: {
  defaultValue?: string;
  children: ReactNode;
  localStorageKey: string;
}) => {
  const [value, setValue] = useLocalStorageState<string>(
    props.localStorageKey,
    {
      defaultValue: props.defaultValue,
    },
  );
  return (
    <Tabs.Root
      value={value}
      onValueChange={(value) => setValue(value)}
      className="c-tabs"
    >
      {props.children}
    </Tabs.Root>
  );
};

export const TabsList = (props: {
  children: ReactNode;
  className?: string;
}) => {
  const {
    children,
    // className
  } = props;
  return <Tabs.List className={"tab__list"}>{children}</Tabs.List>;
};

export const TabsTrigger = (props: {
  children: ReactNode;
  value: string;
  className?: string;
  isDisabled?: boolean;
}) => {
  const { children, className, value, isDisabled } = props;
  return (
    <Tabs.Trigger
      className={className ?? "tab-trigger"}
      value={value}
      onClick={(e) => {
        if (isDisabled) {
          e.preventDefault();
          return;
        }
      }}
      disabled={isDisabled}
    >
      {children}
    </Tabs.Trigger>
  );
};

export const TabsContent = (props: {
  children: ReactNode;
  value: string;
  className?: string;
}) => {
  const { children, className, value } = props;

  return (
    <Tabs.Content className={`tab__content ${className ?? ""}`} value={value}>
      {children}
    </Tabs.Content>
  );
};
